"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const _ = __importStar(require("lodash"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
function SiteListRowSkeleton() {
    const Block = () => {
        return (react_1.default.createElement(Skeleton_1.default, { variant: "rectangular", sx: { width: "256px", height: "282px", marginRight: "16px" } }));
    };
    return (react_1.default.createElement("div", { style: { marginBottom: "40px" } },
        react_1.default.createElement(Skeleton_1.default, { variant: "text", width: "200px", height: "60px" }),
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "start",
                width: "100%",
                height: "100%"
            } },
            _.range(5).map((number) => {
                return react_1.default.createElement(Block, { key: number });
            }),
            " ")));
}
exports.default = SiteListRowSkeleton;
